const lbaSearchBy = angular.module('app.lbaSearchBy', []);

lbaSearchBy.controller('lbaSearchByCtrl', require('./lbaSearchByCtrl'));
lbaSearchBy.directive('lbaSearchBy', require('./lbaSearchByDir'));

export default lbaSearchBy;



// WEBPACK FOOTER //
// ./src/components/lbaSearchBy/index.js